import { CodeSurfer } from "code-surfer";
import { vsDark } from "@code-surfer/themes";
import { Notes } from "mdx-deck";
import "prismjs/components/prism-java";
import "prismjs/components/prism-go";
import "../../../../../../styles.css";
import tweet from "../../../../../../assets/tweet.png";
import locksDiagram from "../../../../../../assets/excalidraw/locks_diagram.png";
import actorDiagram from "../../../../../../assets/excalidraw/actor_diagram.png";
import asyncDiagram from "../../../../../../assets/excalidraw/async_diagram.png";
import locksMeme from "../../../../../../assets/memes/locks_meme.jpg";
import asyncMeme from "../../../../../../assets/memes/async_meme.jpg";
import aiMeme from "../../../../../../assets/memes/ai_meme.jpg";
import qrCode from "../../../../../../assets/qr_code.png";
import * as React from 'react';
export default {
  CodeSurfer,
  vsDark,
  Notes,
  tweet,
  locksDiagram,
  actorDiagram,
  asyncDiagram,
  locksMeme,
  asyncMeme,
  aiMeme,
  qrCode,
  React
};